/* eslint-disable max-params */
import moment from 'moment-timezone';
/**
 * A PropType for validating strings in ISO8601 format
 */
function iso8601(isRequired, props, propName, componentName, location, propFullName) {
    var _a = props, _b = propName, propValue = _a[_b];
    if (propValue == null) {
        if (isRequired) {
            return new Error("Required ".concat(location, " `").concat(propFullName, "` was not specified in ") +
                "`".concat(componentName, "`."));
        }
        return null;
    }
    if (!moment(propValue, moment.ISO_8601).isValid()) {
        var propType = Array.isArray(propValue) ? 'array' : typeof propValue;
        return new Error("Invalid ".concat(location, " `").concat(propFullName, "` of type ") +
            "`".concat(propType, "` supplied to `").concat(componentName, "`, ") +
            'expected an ISO8601 formatted string.');
    }
    return null;
}
var iso8601PropType = iso8601.bind(null, false);
iso8601PropType.isRequired = iso8601.bind(null, true);
export default iso8601PropType;
//# sourceMappingURL=iso8601PropType.js.map